import Controller from '@ember/controller';

export default class DestinationErrorController extends Controller {
  queryParams = ['reason'];

  reason = 'unknown';
}
